import axios from 'axios';
import config from '@/config';
import store from './../index';

const adminEndpoint = `${config.API_URL}/news`;

export const getArticles = (_, { pageNumber = 0, pageSize = 5, manager, monitoring, search }) =>
  new Promise((resolve, reject) =>
    axios
      .get(
        `${adminEndpoint}?${pageSize ? `pageSize=${pageSize}` : ``}${pageNumber ? `&pageNumber=${pageNumber}` : ``}${
          manager ? `&ManagerPublicId=${manager}` : ``
        }${monitoring ? `&PackageLevelPublicId=${monitoring}` : ``}${search ? `&Search=${search}` : ``}`,
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const editArticle = (_, { id, data }) =>
  new Promise((resolve, reject) =>
    axios
      .patch(`${config.API_URL}/admin/news/${id}`, data, {
        headers: { Authorization: `Token ${store.getters.apikey}` },
      })
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const deleteArticle = (_, { id }) =>
  new Promise((resolve, reject) =>
    axios
      .delete(`${config.API_URL}/admin/news/${id}`, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const addArticle = (_, { data }) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${config.API_URL}/admin/news`, data, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response.data))
      .catch(reject),
  );
